import styled from "styled-components";
import { FONTS, responsive } from "Styles/Constants";
import { IMAGES } from "Helpers";

export const SubscriptionDetailsContainer = styled.div`
	font-family: "Outfit", sans-serif;
	.img_text_odd_even .img_text_wrapper_main:last-child .mygrid-row {
		border-bottom: 0 !important;
	}

	.plan_name {
		background-color: #ffffff;
		max-width: 400px;
		width: 100%;
		height: 70px;
		border-bottom-left-radius: 20px;
		border-top-right-radius: 20px;
		color: #021e40;
		font-weight: 600;
		font-size: 29px;
		display: flex;
		align-items: center;
		justify-content: center;
		box-shadow: 0px 4px 10px 0px #00000040;
		cursor: pointer;
	}

	.plan_name.selected {
		background-color: #ffe9d5;
	}

	.plan_name_container {
		display: flex;
		flex-direction: column;
		gap: 20px;
		justify-content: center;
		align-items: center;
		margin-bottom: 100px;
	}
	.plan_name_container_heading {
		width: 100%;
		display: flex;
		flex-direction: row;
		gap: 20px;
		justify-content: space-between;
		align-items: center;
	}
	.plan_name_details_price {
		font-size: 29px;
		font-weight: 600;
		color: #021e40;
		margin: 0;
		text-align: left;
		z-index: 10;
	}
	.plan_name_details_price_per_month {
		font-size: 16px;
		font-weight: 500;
		color: #ee2d2f;
		margin: 0;
		margin-top: 10px;
		margin-bottom: 0px !important;
		font-weight: 700;
		z-index: 10;
	}
	.plan_name_details_price_per_subject {
		font-size: 16px;
		font-weight: 400;
		color: #021e40;
		margin: 0;
		margin-bottom: 0px !important;
		font-weight: 700;
		z-index: 10;
	}
	.plan_name_details_price_per_teacher {
		font-size: 16px;
		font-weight: 400;
		color: #021e40;
		margin: 0;
		margin-bottom: 0px !important;
		font-weight: 700;
		z-index: 10;
	}
	.plan_name_details_price_per_students {
		font-size: 16px;
		font-weight: 400;
		color: #021e40;
		margin: 0;
		font-weight: 700;
		margin-bottom: 0px !important;
		z-index: 10;
	}
	.plan_name_details_price_per_validity {
		font-size: 16px;
		font-weight: 400;
		color: #021e40;
		margin: 0;
		font-weight: 700;
		margin-bottom: 0px !important;
		z-index: 10;
	}
	.layer1_image {
		position: absolute;
		bottom: 0;
		right: 0;
		width: 70%;
		height: auto;
		z-index: 1 !important;
		object-fit: contain;
		opacity: 1;
		pointer-events: none;
	}

	.plan_name_details {
		background-color: #ffcccc;
		display: flex;
		padding: 30px;
		flex-direction: column;
		gap: 10px;
		border-bottom-left-radius: 50px;
		border-top-right-radius: 50px;
		position: relative;
		overflow: hidden;
	}
	.plan_name_details_container {
		display: flex;
		flex-direction: row;
		gap: 20px;
		margin-top: 20px;
		justify-content: space-between !important;
		width: 100%;
		align-items: center;
	}

	.subscription_details_button {
		position: relative;
		z-index: 10 !important;
	}
	.subject_selection_results {
		display: flex;
		align-items: center;
		flex-wrap: wrap;
		margin: 0 -40px;
		justify-content: center;
    	padding-top: 40px;
	}
	.subject_selection_results .subject_selcetion_item {
		padding: 20px 40px;
		width: auto;
		text-align: center;
	}
	.subject_selection_details {
		padding-top: 50px;
		padding-bottom: 80px;
	}
	.subject_selection_details .mygrid-container{
		border-top:  1px solid #A1A0A0;
		padding-top: 50px;
	}
	.subject_selection_details h4.redfont {
		    margin-bottom: 20px;
    font-size: 20px;
	}
	.selected_plan_more_details {
		padding-bottom: 20px;
	}
	.selected_plan_more-row {
		display: flex;
		align-items: center;
		flex-wrap: wrap;
	}
	.selected_plan_more-row .paln_more_item_details {
		padding: 10px 40px;
	}
	.selected_plan_more-row {
		display: flex;
		align-items: center;
		flex-wrap: wrap;
		margin: 0 -40px;
		margin-bottom:30px;
		width: 100%;
	}
	.selected_plan_more-row .paln_more_item_details {
		font-size: 24px;
		font-weight: 700;
	}
	.selected_plan_more-row .paln_more_item_details span {
		font-weight: 400;
		display: inline-block;
		color: #021E40;
	}
	.subject_selcetion_item img {
		filter: grayscale(100%);
		transition: filter 0.3s ease, transform 0.2s ease;
		cursor: pointer;
	}
	.subject_selcetion_item img:hover {
		transform: scale(1.05); 
	}
	.subject_selcetion_item.selected img {
		filter: grayscale(0%);
	}
	.subject_selection_details h4{
		font-weight:600;
	}
	.plan_name_lists {
		padding-bottom: 50px;
		padding-top: 50px;
	}
	.plans_names_wrappers .mygrid-row {
		justify-content: center;
	}
	.plan_name_details {
		margin-bottom: 20px;
	}

	.plan_name_lists .mygrid-row {
		justify-content: center;
	}
	.plan_name_lists .mygrid-row .plan_name {
		margin-bottom: 20px;
	}	
	.subject_selection_details, .subject_selection_results {
		width: 100%;
	}
	.plans_names_wrappers {
		padding-bottom: 100px;
	}
	@media only screen and (max-width: 991px) {
		.plan_name {
			font-size: 18px;
			padding: 10px 25px;
		}
		.about_intro_content {
			flex-wrap: wrap;
			margin-bottom: 0px;
		}
		.plans_names_wrappers {
			padding-bottom: 70px;
		}

	}
	@media only screen and (max-width: 767px){
		.subject_selection_results{
			margin: 0 -10px;
		}
		.subject_selection_results .subject_selcetion_item {
			padding: 10px 10px;
			width:auto;
		}
		.selected_plan_more-row .paln_more_item_details {
			font-size: 18px;
		}
		.selected_plan_more-row .paln_more_item_details {
			padding: 10px 15px;
		}
		.selected_plan_more-row{
			margin: 0 -15px;
			margin-bottom: 30px;
		}
		.selected_plan_more_details {
			padding-bottom: 0px;
		}
		.subject_selection_details{
			padding-bottom: 50px;
		}
		.plans_names_wrappers {
			padding-bottom: 50px;
		}
		.plan_name_lists {
			padding-bottom: 20px;
			padding-top: 20px;
		}
		.about_intro_content {
			margin-bottom: 0px;
		}
	}
	@media only screen and (max-width: 575px){
	
		.plans_names_wrappers .mygrid-col-sm-6 {
			width: 100%;
		}

	}
`;

export const SubscriptionDetailsWrapper = styled.div`
	display: flex;
	flex-direction: column;
	height: 100vh;
	overflow: hidden;
	background-color: #fff;
	width: 100%;
	justify-content: space-between;

	.background-image {
		width: 100%;
		height: 100%;
		overflow: hidden;
		position: absolute;
	}

	.header-container {
		z-index: 10;
		background-color: rgba(255, 255, 255, 0.9);

		.top-bar {
			display: flex;
			justify-content: space-between;
			padding: 1%;
			margin: 0px auto;
			width: 90%;
			.subject-logo {
				background-image: url(${IMAGES.DASHBOARD.SUBJECT_MASTER_LOGO_BLACK});
				width: 110px;
				height: 40px;
				background-repeat: no-repeat;
				background-size: contain;
				cursor: pointer;
			}
			.btn-container {
				display: flex;
				width: auto;
				margin-right: -6%;
				.teacher-btn {
					border-radius: 29.5px;
					width: 180px;
					border: solid 2px rgba(4, 23, 39, 0.3);
					display: flex;
					align-items: center;
					padding: 0px 14px;
					justify-content: center;
					cursor: pointer;
				}
				.login {
					border-radius: 29.5px;
					width: 180px;
					border: solid 2px rgba(4, 23, 39, 0.3);
					display: flex;
					align-items: center;
					padding: 0px 14px;
					justify-content: center;
					margin-left: 10px;
				}
			}
		}
	}

	.footer-container {
		background-color: rgba(255, 255, 255, 0.9);
		padding: 5px;
		width: 100%;
		z-index: 10;

		.inner-container {
			display: flex;
			padding: 0% 1%;
			justify-content: space-between;
			.footer-text {
				color: #000;
				font-size: 18px;
			}

			.page-container {
				display: flex;
				font-size: 16px;
				cursor: pointer;

				.partition {
					margin: 0px 5px;
				}
			}
		}
	}

	.main-container {
		display: flex;
		height: 94%;
		margin: 0px auto;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		width: 80%;
		margin-top: 2%;

		.board-plans {
			z-index: 10;
			display: grid;
			grid-column-gap: 30px;
			grid-template-columns: auto auto auto;

			&.decrease-gird-gap {
				grid-column-gap: 0px;
			}
			.text-board {
				background: url(${IMAGES.LANDING_PAGE.PLAN}) no-repeat center;
				background-size: 100% 100%;
				width: 100%;
				font-size: 28px;
				color: rgba(255, 255, 255, 0.3);
				width: 220px;
				height: 80px;
				display: flex;
				align-items: center;
				justify-content: center;
				cursor: pointer;
				font-family: ${FONTS.QUATERNARY};
				font-weight: 600;
				&.selected {
					color: #fff;
					background: url(${IMAGES.LANDING_PAGE.PLAN_SELECTED}) no-repeat center;
					background-size: 100% 100%;
					height: 100px;
					padding-bottom: 18px;
					transform: scale(1.2);
					${responsive.LAPTOP`
						font-size: 22px
						width: 180px;
					`}
					${responsive.TABLET`
						font-size: 20px
						width: 180px;
						padding-bottom: 27px;
        			`}
				}
				&.disable {
					pointer-events: none;
				}
				${responsive.DESKTOP`
					font-size: 25px
					width: 220px;
					height: 80px;
				`}

				${responsive.LAPTOP`
					font-size: 25px
					width: 220px;
					height: 80px;
				`}
				${responsive.TABLET`
					font-size: 25px
					width: 170px;
					height: 60px;
        		`}
			}
		}

		.email-board {
			background: url(${IMAGES.LANDING_PAGE.BOARD}) no-repeat center;
			background-size: 100% 100%;
			width: 80%;
			height: 80%;
			display: flex;
			flex-direction: column;
			align-items: center;
			justify-content: center;
			color: #fff;

			.text-one {
				font-size: 22px;
			}
			.text-two {
				font-size: 20px;
			}
		}

		.board {
			background: url(${IMAGES.LANDING_PAGE.BOARD}) no-repeat center;
			background-size: 100% 100%;
			width: 80%;
			height: 100%;
			margin-top: -22px;
			z-index: 1;
			${responsive.DISPLAY_1600`
          		width: 90%
				height : 85%
			`}
			${responsive.DESKTOP`
          		width: 100%
			`} 
			/* ${responsive.LAPTOP_1050`
			
       			width: 90%
				height : 85%
			`} */
			/* ${responsive.LAPTOP`
          		width: 90%
				height : 70%
				margin-top: -18px;
			`} */
			${responsive.LAPTOP`
          		width: 100%
				height : 70%
				margin-top: -18px;
			`}
			${responsive.TABLET`
            	width: 85%;
				height : 60%
				margin-top: -15px;
        	`}
			${responsive.TABLET_725`
            	width: 95%;
				height : 50%
				margin-top: -15px;
        	`}
		}
	}
`;

export const SubscriptionPlansWrapper = styled.div`
	.main-container {
		.select-plan-plate {
			width: 442px;
			height: 135px;
			display: flex;
			margin: 46px 0px;
			align-items: center;
			flex-direction: column;
			justify-content: space-between;
			/* background: url(${IMAGES.LANDING_PAGE.SELECT_PLAN_BOARD}) no-repeat center; */
			background-size: 100% 100%;

			.select-plan {
				font-size: 35px;
				font-family: ${FONTS.QUATERNARY};
				font-weight: 600;
				margin: 0 !;
				color: #021e40;
				cursor: pointer;
				${responsive.LAPTOP`
      				font-size: 25px;
				`}

				${responsive.DISPLAY_1600`
				  	font-size: 25px;
				`}
			}

			${responsive.DISPLAY_1600`
          		width: 30%
				height : 80px
			`}

			${responsive.LAPTOP`
      			width: 50%;
				height : 80px;
			`}
		}
		.plans {
			display: flex;
			div:nth-child(2) {
				margin: 70px -16px 0px -19px;
			}
			div:nth-child(4) {
				margin: 70px 0 0 -22px;
			}

			@media (max-height: 790px) {
				div:nth-child(2) {
					margin: 0px !important;
				}
				div:nth-child(4) {
					margin: 0px !important;
				}
			}

			${responsive.DISPLAY_1600`
				div:nth-child(2) {
					margin: 70px 20px 0px 20px;
				}
				div:nth-child(4) {
					margin: 70px 0 0 20px;
				}	
			`}
		}
	}
`;

export const StickerWrapper = styled.div`
	width: 289px;
	height: 320px;
	background: url(${(props) => props.stickerImage}) no-repeat center;
	background-size: 100% 100%;
	&:hover {
		cursor: pointer;
		transform: scale(1.05);
		filter: drop-shadow(4px 4px 6px ${(props) => props.hoverEffectColor});
	}

	:active {
		transform: scale(1.08);
	}

	&.selected {
		filter: drop-shadow(4px 4px 6px ${(props) => props.hoverEffectColor});
	}

	${responsive.DISPLAY_1600`
        max-width: 200px;
		max-height: 220px;
	`}
	${responsive.DESKTOP`
        width: 200px;
		height: 220px;
	`}
	${responsive.LAPTOP`
        width: 180px;
		height: 200px;
	`}
	${responsive.LAPTOP_1050`
        width: 153px;
		height: 163px;
	`}
	${responsive.TABLET`
        width: 110px;
		height: 130px;
		margin : 10px
	`}
`;

export const SubscriptionSubjectsWrapper = styled.div`
	display: flex;
	flex-direction: column;
	gap: 30px;
	.main-container {
		display: flex;
		flex-direction: row;
		justify-content: space-between;
		.select-plan-plate {
			width: 100%;

			/* background: url(${IMAGES.LANDING_PAGE.SELECT_PLAN_BOARD}) no-repeat center; */
			height: 110px;
			margin: 46px 0px;
			object-fit: contain;
			display: flex;
			gap: 40px;
			align-items: center;
			justify-content: center;
			background-size: contain;
			.select-plan {
				font-size: 35px;
				font-weight: 600;
				margin-bottom: 15px;
				color: #021e40;
				${responsive.DISPLAY_1600`
				  font-size: 25px;
				`}
			}
			${responsive.DESKTOP`
          		width: 40%
				height : 80px
			`}
			${responsive.DISPLAY_1600`
          		width: 30%
				height : 80px
			`}
			${responsive.LAPTOP`
      			width: 50%;
				height : 80px;
			`}
		}
		.flex {
			display: flex;
			justify-content: center;
			align-items: center;
			gap: 10px;

			.direction-button {
				background: url(${IMAGES.LANDING_PAGE.DIRECTION_BUTTON}) no-repeat center;
				height: 40px;
				width: 40px;
				background-size: cover;
				transition: all 0.3s ease;
				cursor: pointer;
				${responsive.LAPTOP`
    				height: 30px;
					width: 30px;
				`}
				&.back {
					-webkit-transform: rotate(180deg);
					transform: rotate(180deg);
					cursor: pointer;
				}

				&:hover {
					cursor: pointer;
					transform: scale(1.1);
					filter: brightness(1.2);
				}

				&:active {
					transform: scale(0.95);
				}

				&.hide-visibility {
					visibility: hidden;
				}
			}
			.font {
				font-size: 24px;
				font-family: ${FONTS.QUINARY};
				font-weight: 500;
				color: white;
				text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.7);
				transition: all 0.3s ease;
				cursor: pointer;
				user-select: none;

				&:hover {
					color: #ffeb3b;
					transform: scale(1.05);
				}

				&.hide-visibility {
					visibility: hidden;
				}
				${responsive.LAPTOP`
					font-size: 20px;
				`}
			}
		}
	}
		.select-plan-plate {
			display: flex;
			align-items: center;
			justify-content: space-between;
			background: #f9f9f9;
			border-radius: 16px;
			padding: 16px 24px;
			box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
			gap: 20px;
			}

			.select-plan-plate h4 {
			flex: 1;
			text-align: center;
			font-size: 18px;
			font-weight: 600;
			margin: 0;
			color: #c62828; /* redfont */
			}

			.select-plan-btn {
			padding: 10px 20px;
			border-radius: 12px;
			font-size: 14px;
			font-weight: 500;
			cursor: pointer;
			transition: all 0.3s ease;
			border: none;
			}

			.select-plan-btn.back {
			background: transparent;
			color: #021e40;
			border: 2px solid #021e40;
			}

			.select-plan-btn.back:hover {
			background: #021e40;
			color: #fff;
			}

			.select-plan-btn.next {
			background: #021e40;
			color: #fff;
			}

			.select-plan-btn.next:hover {
			background: #033568;
			transform: translateY(-2px);
			box-shadow: 0 3px 8px rgba(0, 0, 0, 0.2);
			}

	.subject-sticker-parent {
		display: flex;
		flex-direction: row;
		gap: 20px;
		justify-content: center;

		${responsive.LAPTOP`
        	width: 90%;
			margin: 0px auto;
		`}

		div:nth-child(even) {
			margin-top: 70px;
		}
		@media (max-height: 745px) {
			div:nth-child(odd) {
				margin-top: -25px !important;
			}
			div:nth-child(even) {
				margin-top: 10px !important;
			}
		}
	}

	.select-plan-plate{
    display: flex;
justify-content: space-between;
    gap: 20px;
	}
	.select-plan-plate {
		display: flex;
		align-items: center;
justify-content: space-between;
	}
.select-plan-plate h4.redfont {
    margin-bottom: 0;
}
@media only screen and (max-width: 767px) {
	.subject_selection_results .subject_selection_item {
	width: auto !important;
	}
	.select-plan-plate{
	padding: 15px 15px;
	}
	.select-plan-plate h4.redfont {
	font-size: 16px !important;
	}
}



`;
export const SubscriptionSummaryWrapper = styled.div`
	// min-height: 100vh;

	.summary-containers {

		.back_boxed {
			background: transparent;
			color: #021e40;
			font-size: 14px;
			font-weight: 600;
			border: 2px solid #021e40;
			border-radius: 8px;
			padding: 10px 20px;
			cursor: pointer;
			transition: all 0.3s ease;
					}
			.back_boxed:hover {
			background: #021e40;
			color: #fff;
			}
			.status-board {
			display: flex;
			align-items: center;
			justify-content: center;
			height: 300px;

			.text-one {
			    color: #021E40;
			    font-weight: 700;
			    font-size: 26px;
			}
		}

		.header {
			display: flex;
			flex-direction: row;
			justify-content: space-between;
			width: 100%;
			.flex-header {
				display: flex;
				justify-content: center;
				align-items: center;
				gap: 10px;
				width: 100%;
    			margin-bottom: 40px;
				padding: 16px 24px;
				box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
				.direction-button {
					background: url(${IMAGES.LANDING_PAGE.DIRECTION_BUTTON}) no-repeat center;
					height: 40px;
					width: 40px;
					background-size: cover;
					transition: all 0.3s ease;
					&.back {
						-webkit-transform: rotate(180deg);
						transform: rotate(180deg);
					}
					&.hide-visibility {
						visibility: hidden;
					}
					&:hover {
						cursor: pointer;
						transform: scale(1.1);
						filter: brightness(1.2);
					}
					&:active {
						transform: scale(0.95);
					}
					${responsive.LAPTOP`
    					height: 30px;
						width: 30px;
					`}
				}
				.font {
					font-size: 24px;
					font-family: ${FONTS.QUINARY};
					font-weight: 500;
					color: white;
					text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.7);
					transition: all 0.3s ease;
					cursor: pointer;
					user-select: none;

					&:hover {
						color: #ffeb3b;
						transform: scale(1.05);
					}

					&.hide-visibility {
						visibility: hidden;
					}
				}
				.registerAsSchoolFont {
					font-size: 18px;
					font-family: ${FONTS.QUINARY};
					font-weight: 400;
					color: white;
					width: 100px;
					text-align: end;
					text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.7);
					transition: all 0.3s ease;
					cursor: pointer;
					user-select: none;

					&:hover {
						color: #ffeb3b;
						transform: scale(1.05);
					}

					${responsive.LAPTOP`
						font-size: 20px;
					`}
				}
			}

			.summary-details {
				background: url(${IMAGES.LANDING_PAGE.SUMMARY_NOTE}) no-repeat center;
				background-size: 100% 100%;
				width: 45%;
				padding: 2% 5% 3%;
				.plan-name {
					text-align: center;
					font-size: 24px;
					font-family: ${FONTS.QUATERNARY};
					font-weight: bold;
					${responsive.LAPTOP`
						font-size: 18px;
					`}
				}

				.summary-pan-container {
					display: flex;
					justify-content: space-between;

					margin-top: 4%;
					margin-bottom: 2%;

					.tick {
						font-size: 22px;
						${responsive.LAPTOP`
							font-size: 10px;
						`}
					}

					.sub-plan {
						font-size: 18px;
						font-family: ${FONTS.QUATERNARY};
						font-weight: bold;
						${responsive.LAPTOP`
							font-size: 10px;
						`}
					}

					.price {
						font-size: 18px;
						font-family: ${FONTS.QUATERNARY};
						font-weight: bold;
						${responsive.LAPTOP`
							font-size: 10px;
						`}
					}

					.amount {
						font-size: 18px;
						margin-left: 5px;
						font-family: ${FONTS.QUATERNARY};
						color: #db0202;
						font-weight: bold;
						${responsive.LAPTOP`
							font-size: 10px;
						`}
					}
				}
			}
		}

		.selected-subjects {
			display: flex;
			flex-wrap: wrap;
			justify-content: center;
			height: 420px;
			overflow-y: auto;
			width: 100%;
			${responsive.DISPLAY`
    			height : 320px
			`}
		}
	}
		.selected_plan_more_details .mygrid-container {
			border: 0 !important;
			padding-top: 0 !important;
		}
.flex-header.bck_btn_summary {
  display: flex;
  align-items: center;
  justify-content: space-between; /* keeps back button left, title centered */
  padding: 12px 20px;
  background: #f9f9f9;
  border-bottom: 1px solid #e0e0e0;
  border-radius: 12px;
  position: relative;
}

.flex-header.bck_btn_summary h4 {
  flex: 1;
  text-align: center;
  margin: 0;
  font-size: 20px;
  font-weight: 600;
  color: #c62828; /* redfont */
}

.back_boxed {
  background: transparent;
  color: #021e40;
  font-size: 14px;
  font-weight: 600;
  border: 2px solid #021e40;
  border-radius: 8px;
  padding: 6px 14px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.back_boxed:hover {
  background: #021e40;
  color: #fff;
}

`;

export const SubjectSticker = styled.div`
	background: url(${(props) => props.stickerImage}) no-repeat center;
	width: 131px;
	height: 216px;
	background-size: cover;
	border-top-right-radius: 50px;
	border-bottom-left-radius: 50px;
	filter: grayscale(1);
	cursor: pointer;
	&:hover {
		/* transform: scale(1.05); */
		filter: grayscale(0);
		filter: drop-shadow(0px 0px 8px ${(props) => props.backgroundGlowColor});
		/* border: 2px solid ${(props) => props.borderColor};
		border-radius: 10px; */
	}
	:active {
		transform: scale(1.03);
		/* filter: grayscale(0); */
	}
	&.selected {
		filter: grayscale(0);
		/* transform: scale(1.05); */
		filter: drop-shadow(0px 0px 8px ${(props) => props.backgroundGlowColor});
		border: 2px solid ${(props) => props.borderColor};
		border-radius: 10px;
	}
	${responsive.DISPLAY_1600`
		width: 111px;
		height: 180px;
		background-size: 100%, 100%;
	`}

	${responsive.LAPTOP_1050`
    	width: 111px;
		height: 146px;
		background-size: 100%, 100%;
	`}
	${responsive.TABLET`
    	height : 118px
		margin-top: -15px;
	`}
`;

export const SelectedSubjectWrapper = styled.div`
	background: url(${(props) => props.subjectImage}) no-repeat center;
	background-size: contain;
	flex: 0 0 25%;
	@media (max-height: 900px) {
		flex: 0 0 17%;
	}
	@media (max-height: 800px) {
		flex: 0 0 14%;
	}
`;

export const SubscriptionPaymentWrapper = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	height: 100%;

	.payment-sticker-success {
		width: 390px;
		height: 394px;
		background: url(${IMAGES.LANDING_PAGE.PAYMENT_SUCCESS}) no-repeat center;
		object-fit: contain;
		display: flex;
		align-items: center;
		justify-content: center;
		flex-direction: column;
		background-size: 100% 100%;
	}
	.payment-sticker-fail {
		width: 390px;
		height: 394px;
		background: url(${IMAGES.LANDING_PAGE.PAYMENT_FAIL}) no-repeat center;
		object-fit: contain;
		display: flex;
		align-items: center;
		justify-content: center;
		flex-direction: column;
	}
	.try-again-parent {
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: center;
		gap: 15px;
		cursor: pointer;

		.redirect {
			font-size: 20px;
			font-family: ${FONTS.QUINARY};
			font-weight: 500;
			color: white;
		}

		.font {
			font-size: 24px;
			font-family: ${FONTS.QUINARY};
			font-weight: 500;
			color: white;
		}

		.try-again {
			width: 52px;
			height: 52px;
			background: url(${IMAGES.LANDING_PAGE.TRY_AGAIN}) no-repeat center;
			object-fit: contain;
			display: flex;
			align-items: center;
			justify-content: center;
			flex-direction: column;
		}
	}
`;
